/**
 * Return an error message if password is weak, else null.
 * Mirrors backend _validate_password_strength.
 */
export function validatePasswordStrength(password) {
  if (
    !password ||
    password.length < 10 ||
    !/[A-Z]/.test(password) ||
    !/[a-z]/.test(password) ||
    !/[0-9]/.test(password) ||
    !/[^A-Za-z0-9]/.test(password)
  ) {
    return 'Password must be at least 10 characters and include at least one uppercase letter, one lowercase letter, one number and one symbol.';
  }
  return null;
}
